/* AIRSOUND theme JS */
(function () {
  'use strict';

  /* ---------- Scroll animations ---------- */
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            observer.unobserve(e.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' })
    : null;

  document.querySelectorAll('[data-animate]').forEach((el) => {
    if (observer) observer.observe(el);
    else el.classList.add('is-visible');
  });

  /* ---------- Header sticky shadow ---------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile menu ---------- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = !mobileMenu.hasAttribute('hidden');
      if (isOpen) {
        mobileMenu.setAttribute('hidden', '');
        menuToggle.setAttribute('aria-expanded', 'false');
      } else {
        mobileMenu.removeAttribute('hidden');
        menuToggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ---------- Product gallery ---------- */
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const slides = document.querySelectorAll('.product-gallery__slide');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const idx = thumb.dataset.index;
      thumbs.forEach((t) => t.classList.remove('is-active'));
      slides.forEach((s) => s.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const slide = document.querySelector(`.product-gallery__slide[data-index="${idx}"]`);
      if (slide) slide.classList.add('is-active');
    });
  });

  /* ---------- Quantity selector ---------- */
  document.querySelectorAll('[data-qty-input]').forEach((input) => {
    const wrap = input.closest('.qty-selector');
    if (!wrap) return;
    const minus = wrap.querySelector('[data-qty-minus]');
    const plus = wrap.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', () => {
      const v = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = v;
    });
    if (plus) plus.addEventListener('click', () => {
      const v = Math.max(1, parseInt(input.value || '1', 10) + 1);
      input.value = v;
    });
  });

  /* ---------- Variant selection (basic) ---------- */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const options = form.querySelectorAll('[data-variant-option]');
    options.forEach((opt) => {
      opt.addEventListener('change', () => {
        // toggle selected state
        const name = opt.name;
        form.querySelectorAll(`input[name="${name}"]`).forEach((i) => {
          i.closest('.variant-pill')?.classList.toggle('is-selected', i.checked);
        });
      });
    });
  });

  /* ---------- Cart count refresh ---------- */
  window.updateCartCount = function () {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});
  };
})();
